<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-receipt">&nbsp; Return Receipts</h5>
        </div>
        <div class="col-auto text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="loadReturns()" :disabled="loading">&nbsp; Reload</button>
        </div>
        <!-- <div class="col-auto p-0">
          <button class="btn w-100 btn-success bi-file-earmark-excel-fill" @click="xlsx()" :disabled="loading">&nbsp; Excel</button>
        </div> -->
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">

        <div class="col-3 p-0">
          <div class="input-group w-100">
            <span class="input-group-text w-25">Branch</span>
            <select class="form-select" v-model="branch" @change="loadReturns()">
              <option value="*">All Branches</option>
              <option v-for="b in branches" :key="b._id" :value="b._id">{{ b.name }}</option>
            </select>
          </div>
          <!-- <div class="input-group w-100">
            <span class="input-group-text">Search</span>
            <input class="form-control" type="text" v-model.trim="searchKey" @change="loadInvoices()">
            <button class="btn btn-primary bi-search" @click="loadInvoices()" :disabled="loading"></button>
          </div> -->
        </div>
        
        <div class="col-9 pe-0">
          <div class="input-group w-100">
            <span class="input-group-text">From</span>
            <input class="form-control w-20" type="date" v-model="from">
            <span class="input-group-text">To</span>
            <input class="form-control w-20" type="date" v-model="to">
            <span class="input-group-text">Keyword</span>
            <input class="form-control" type="text" placeholder="invoice id or customer name, phone, or car" v-model="invoice_id">
            <button class="btn btn-primary bi-filter" @click="loadReturns()" :disabled="loading"></button>
          </div>
        </div>
        
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <table class="table table-sm table-bordered table-striped table-hover table-fixed">
      <!-- ----------------------------------------------- -->
      <thead>
        <tr class="table-dark">
          <th class="">Invoice</th>
          <th class="w-20">Date</th>
          <th class="w-20">Branch</th>
          <th class="w-20">User</th>
          <th class="w-10 text-center">Total</th>
          <th class="text-center w-50px"><span class="bi-gear"></span></th>
        </tr>
      </thead>
      <!-- ----------------------------------------------- -->
      <tbody style="height: calc(100vh - 190px)">        
        <tr v-for="receipt in returns" :key="receipt._id">
          <td class="">{{ receipt.invoice }}</td>
          <td class="w-20">{{ receipt.date }}</td>
          <td class="w-20">{{ receipt.branch }}</td>
          <td class="w-20">{{ receipt.user == 'super' ? '' : receipt.user }}</td>
          <td class="w-10 text-center">{{ formatMoney(receipt.total) }}</td>
          <td class="dropstart text-center w-50px">
            <a data-bs-toggle='dropdown' class="btn btn-sm btn-secondary p-1"><span class="bi-three-dots-vertical"></span></a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item bi-eye" @click="viewReceipt(receipt._id)">View</a></li>
            </ul>
          </td>
        </tr>
      </tbody>
      <!-- ----------------------------------------------- -->
    </table>
    <!-- =========================================================================================================== -->
    <ReturnReceipt ref="receipt"></ReturnReceipt>
    <!-- =========================================================================================================== -->
    <!-- =========================================================================================================== -->
  </div>

</template>
<!-- ******************************************************** -->
<script>
  // const $ = require('jquery');
  // const bootstrap = require('bootstrap');
  import ReturnReceipt from '@/components/ReturnReceipt.vue';
  // eslint-disable-next-line
  export default {
    name: 'ReturnsPage',
    props: {
      iid: {
        type: String,
        required: false,
        default: '',
      },
    },
    components: {
      ReturnReceipt
    },
    data(){
      return {
        loading: false,
        
        branches: [],
        returns: [],

        branch: '*',
        invoice_id: '',
        from: '',
        to: '',

      }
    },
    async created(){
      await this.loadBranches();
      if(this.$route.params.cid){
        this.invoice_id = this.$route.params.iid;
        this.from = this.$getEpochStart();
        this.to = this.$getCurrentDay();
      }
      else{
        this.from = this.$getMonthStart();
        this.to = this.$getNextMonthStart();
        // this.to = this.$getMonthEnd();
      }
      await this.loadReturns();

      var code = "", reading = false;
      document.addEventListener('keypress', (e) => {
        if (e.keyCode === 13) {
            if(code.length >= 8) {
              this.onBarcodeScan(code);
              code = "";
            }
        }
        else { code += e.key; }
        if(!reading) {
            reading = true;
            setTimeout(() => { code = ""; reading = false;}, 200);
        }
      });
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async loadBranches(){
        this.loading = true;
        this.branches = [];
        var ack = await this.$service.getBranchesAbstract();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.branches = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async loadReturns(){
        this.loading = true;
        this.returns = [];
        var ack = await this.$service.getReturns({
          invoice_id: this.invoice_id,
          branch: this.branch,
          from: this.from,
          to: this.to,
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.returns = ack.data;
          // let arr = Array.from(document.getElementsByClassName('tooltip'));
          // arr.forEach((x)=>new bootstrap.Tooltip(x));
        }
        this.loading = false;
      },
      //**********************************************************
      async viewReceipt(receipt_id){
        this.loading = true;
        await this.$refs.receipt.view(receipt_id);
        this.loading = false;
      },
      //**********************************************************
      async onBarcodeScan(code){
        this.searchKey = code;
      },
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
.returned-badge{
  position: absolute;
  top: 5px;
  right: 5px;
}
</style>
  